import React from 'react';
import { Divider, Menu, MenuItem } from '@mui/material';

const SendActionsMenu = ({
  anchorEl,
  row,
  onClose,
  onSendDirect,
  onSendWithNotes,
  enableVmtQuickActions,
  onQuickAction,
  onOpenPopcorn,
  onOpenSetDates,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    disableScrollLock
  >
    <MenuItem
      onClick={(event) => {
        event.stopPropagation();
        onSendDirect(row);
      }}
    >
      Send to staging
    </MenuItem>
    <MenuItem
      onClick={(event) => {
        event.stopPropagation();
        onSendWithNotes(row);
      }}
    >
      Send with notes
    </MenuItem>
    {enableVmtQuickActions
      ? [
          <Divider key="quick-actions-divider-1" />,
          <MenuItem
            key="quick-force-live"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'forceLive');
            }}
          >
            Force Live
          </MenuItem>,
          <MenuItem
            key="quick-force-pending-live"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'forcePendingLive');
            }}
          >
            Force Pending Live
          </MenuItem>,
          <MenuItem
            key="quick-force-cancelled"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'forceCancelled');
            }}
          >
            Force Cancelled
          </MenuItem>,
          <MenuItem
            key="quick-cancel-unmatch"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'cancelAndUnmatch');
            }}
          >
            Cancel &amp; Unmatch
          </MenuItem>,
          <MenuItem
            key="quick-force-pending-cancel"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'forcePendingCancel');
            }}
          >
            Force Pending Cancel
          </MenuItem>,
          <Divider key="quick-actions-divider-2" />,
          <MenuItem
            key="quick-secondary-pricing"
            onClick={(event) => {
              event.stopPropagation();
              onQuickAction(row, 'forceSecondaryPricing');
            }}
          >
            Force Secondary Pricing
          </MenuItem>,
          <MenuItem
            key="quick-popcorn-parent"
            onClick={(event) => {
              event.stopPropagation();
              onOpenPopcorn(row);
            }}
          >
            Force Popcorn Parent Live
          </MenuItem>,
          <MenuItem
            key="quick-set-dates"
            onClick={(event) => {
              event.stopPropagation();
              onOpenSetDates(row);
            }}
          >
            Set Dates…
          </MenuItem>,
        ]
      : null}
  </Menu>
);

export default SendActionsMenu;
